import { HTTP } from "../../../http-common";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "../../../models/httpError";
import { Term } from "../../../models/term";

const state = {
  rows: [],
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  addRow(state) {
    state.rows.push(new Term());
  },
  addItem(state) {
    state.rows.termItems.push(new TermItem());
  },
  addNewItem(state, termItem) {
    state.rows[state.rows.length - 1].termItems.push(termItem);
  },
  clearRows(state) {
    state.rows.length = 0;
    state.rows.push(new Term());
    state.message = new httpError();
  },
  removeTerm(state, termID) {
    //state.rows = state.rows.filter((x) => x.id !== termID);
    state.rows = state.rows.filter((x) => x.id);
  },
  removeItemTerm(state, termItem) {
    state.rows.termItems = state.rows[termItem.sectionIndex].termItems.filter(
      (x) => x.id !== termItem.termID
    );
  },
  setProgress(state, message) {
    state.message = message;
  },
  setRows(state, data) {
    state.rows = data;
  },
  updateField,
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit("clearRows");
  },
  getTerms({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("order/GetAllTermConditions/")
        .then((data) => {
          if (data.status === 200) {
            commit("setRows", data.data);
            dispatch(
              "setMessage",
              new httpError({
                message: "Retrieved OK",
                httpStatus: 200,
              })
            );
            resolve(data.data);
          }
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500,
            })
          );
          reject(err.response.status);
        });
    });
  },
  getTermItems({ dispatch }, termID) {
    return new Promise((resolve, reject) => {
      HTTP.get(`order/GetTermItems/${termID}`)
        .then((data) => {
          if (data.status === 200) {
            dispatch(
              "setMessage",
              new httpError({
                message: "Retrieved OK",
                httpStatus: 200,
              })
            );
            resolve(data.data);
          }
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500,
            })
          );
          reject(err.response.status);
        });
    }); 
  },
  removeTerm({ commit, dispatch }, termID) {
    return new Promise((resolve, reject) => {
      if (!termID) reject("No term supplied");
      HTTP.delete("order/DeleteTermCondition/" + termID)
        .then(() => {
          commit("removeTerm", termID);
          dispatch(
            "setMessage",
            new httpError({
              message: "Retrieved OK",
              httpStatus: 200,
            })
          );
          resolve();
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  editTermItem({ dispatch, state }, termItem) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        `order/UpdateTermConditionsItem/${termItem.termsConditionsID}`,
        termItem
      )
        .then((data) => {
          if (data.status == 200) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  addTermItem({ dispatch, commit }, termItem) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        `order/UpdateTermConditionsItem/${termItem.termsConditionsID}`,
        termItem
      )
        .then((data) => {
          if (data.status == 200) {
            commit("addNewItem", data.data);
            resolve(data.data);
          }
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  deleteTermsCondition({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      //HTTP.delete("order/DeleteTermIndex/" + payload.termItemIndex)
      HTTP.delete(`order/DeleteTermCondition/${id}`)
        .then((data) => {
          if (data.status == 200) {
            //commit("removeTerm", payload);
            //commit("setRows", data);
            dispatch("getTerms");
            resolve(data.data);
          }
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  removeTermItem({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      //HTTP.delete("order/DeleteTermIndex/" + payload.termItemIndex)
      HTTP.post(`order/DeleteTermIndex/${payload.termItemIndex}`)
        .then((data) => {
          if (data.status == 200) {
            commit("removeItemTerm", payload);
            resolve(data.data);
          }
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  populateTerms({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(
        "order/GetTermsConditions/" + rootState.orders.rows[0].orderGUID
      );
      response
        .then(function (data) {
          if (data.status === 200) {
            commit("setRows", data.data);
            dispatch(
              "setMessage",
              new httpError({
                message: "Retrieved OK",
                httpStatus: 200,
              })
            );
          }
          resolve(data.data);
          return;
        })
        .catch(function (err) {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error" + err.message,
              httpStatus: 500,
            })
          );
          if (err.response.status == 401) {
            reject(401);
          }
          reject(err.response.status);
        });
    });
  },
  updateTerms({ dispatch, state }, {
    termIndex,
    isUpdate = true,
    editedItem
  }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "order/UpdateTermConditions",
        !isUpdate ? editedItem : state.rows[termIndex]
      );
      response
        .then((data) => {
          if (data.status == 200) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateTermsOnOrder({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "order/UpdateTermsConditionsOnOrder/" +
        rootState.orders.rows[0].orderGUID,
        state.rows
      );
      response
        .then((data) => {
          if (data.status == 200) {
            commit("setRows", data.data);
          }
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateTermItem({ dispatch }, termItem) {
    return new Promise((resolve, reject) => { });
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
